import { defineComponent } from "vue";
import { setupConcurrencyLimit } from "@/utils/AxiosConcurrencyLimit";

/**
 * Applies the server-provided AJAX concurrency limit to the shared HTTP client (Axios).
 */
export default defineComponent({
	name: "AjaxConfigRegistration",
	props: {
		/**
		 * Server-provided limit on maximum concurrent in-flight AJAX requests.
		 */
		concurrencyLimit: {
			type: Number,
			required: true,
		},
	},
	/**
	 * Applies the server-provided cap when positive. `0` skips setup (limiter off).
	 */
	created() {
		if (this.concurrencyLimit === 0) {
			return;
		}

		setupConcurrencyLimit(this.concurrencyLimit);
	},
	/**
	 * A render function is required when a Vue component lacks a `<template>`.
	 * Since this is a logical component with no rendered DOM elements, we return `undefined`
	 * to prevent errors or warnings.
	 */
	render() {
		return undefined;
	},
});
